<script lang="ts" setup>
import { useUserStoreRef } from '@/stores/userStore';
import { FederationFocusView, SuperAdminFocusView, NormalFocusView } from '@/components/views';
import ContentComp from '@/components/layout/ContentComp.vue';
import { $ti } from '@/locize';
import { QuickCreate } from '@/components';
import { useLoaders, useTaskLoader } from '@/composeables';

const { user } = useUserStoreRef();

const { LoadState, AddLoader } = useTaskLoader();
useLoaders(AddLoader, ['FEDERATIONS', 'ORGANIZERS']);
</script>

<template>
    <ContentComp
        class="h-100 overflow-auto"
        :loadState="LoadState"
    >
        <h1 class="display-2">{{ $ti('home.welcome', { name: user?.Name }) }}</h1>
        <div class="d-flex flex-inline">
            <span>
                <QuickCreate />
            </span>
        </div>

        <SuperAdminFocusView v-if="user?.IsSuperAdmin" />
        <FederationFocusView v-else-if="user?.IsFederation" />
        <NormalFocusView v-else />
    </ContentComp>
</template>
